
import axios from "axios";
import { useAuth } from "../navigation/AuthProvider";
import { BACKEND_URL } from "../constants";





export const add_new_project_to_company = async ({newProject, company, user}) => {

    if(!user || !company || !newProject.name) return alert("Otillräcklig information given")


    const { data } = await axios.post(`${BACKEND_URL}/add-new-project`, {
        userId: user._id,
        companyId: company._id,
        newProject
    }, { withCredentials: true })

    return data
}


export const edit_project = async ({company, user, project, updatedProjectValues}) => {

    if(!company || !user || !project || !updatedProjectValues) return void null

    const { data } = await axios.post(`${BACKEND_URL}/edit-project`, {
        companyId: company._id,
        userId: user._id,
        projectId: project._id,
        updatedProjectValues
    }, { withCredentials: true })

    return data
}


export const delete_project = async ({company, user, project}) => {

    if(!company || !user || !project) return void null

    const { data } = await axios.post(`${BACKEND_URL}/delete-project`, {
        companyId: company._id,
        userId: user._id,
        projectId: project._id
    }, {withCredentials: true})

    return data
}


export const add_employee_to_project = async ({user, company, project, employeeId }) => {
    if(!company || !user || !project || !employeeId) return alert("Kunte inte skicka förfrågan till servern")

    const { data } = await axios.post(`${BACKEND_URL}/add-employee-to-project`, {
        userId: user._id,
        companyId: company._id,
        projectId: project._id,
        employeeId,
    }, {withCredentials: true})
    return data
}


export const remove_employee_from_project = async ({user, company, project, employeeId }) => {
    if(!company || !user || !project || !employeeId) return alert("Kunte inte skicka förfrågan till servern")

    const { data } = await axios.post(`${BACKEND_URL}/remove-employee-from-project`, {
        userId: user._id,
        companyId: company._id,
        projectId: project._id,
        employeeId,
    }, {withCredentials: true})
    return data
}